export default {
  methods: {
    getStateByNumber(state) {
      if (state === 1) {
        return this.$t("subscriptions.status.canceled");
      }
      if (state === 2 || state === 7) {
        return this.$t("transactions.status.succeeded");
      }
      if (state === 3) {
        return this.$t("subscriptions.status.active");
      }
      if (state === 4 || state === 17) {
        return this.$t("transactions.status.pending");
      }
      if (state === 13) {
        return this.$t("transactions.status.refunded");
      }
      if (state === 16) {
        return this.$t("subscriptions.status.incomplete");
      }
      if (state === 18) {
        return this.$t("subscriptions.status.prenotified");
      }
      return this.$t("transactions.dashboard.failed");
    },
    getStateByName(state) {
      switch (state) {
        case "active":
        case "trialing":
          return this.$t("subscriptions.status.active");
        case "incomplete":
          return this.$t("subscriptions.status.incomplete");
        case "success":
          return this.$t("transactions.status.succeeded");
        case "pending":
          return this.$t("transactions.status.pending");
        case "failed":
          return this.$t("transactions.dashboard.failed");
        case "cancel":
          return this.$t("subscriptions.status.canceled");
        case "refunded":
          return this.$t("transactions.status.refunded");
        default:
          return state;
      }
    },
    getStateValueByName(state) {
      switch (state) {
        case "cancel":
          return 1;
        case "success":
          return 2;
        case "active":
          return 3;
        case "pending":
          return 4;
        case "failed":
          return 5;
        case "trialing":
          return 6;
        case "refunded":
          return 13;
        case "incomplete":
          return 16;
        default:
          return null;
      }
    },
    getStateForColor(state) {
      if ([13, 4, 17, 18].includes(state)) {
        return "rgba(0, 0, 0, 0.8)";
      }
      return "";
    },
    getStateForFontWeight(state) {
      if ([13, 4, 17, 18].includes(state)) {
        return "900";
      }
      return "";
    },
    getStateForTextColor(state) {
      if ([2, 7, 3, 19].includes(state)) {
        return "green--text text--accent-4 font-weight-black";
      }
      if ([13, 4, 17, 18].includes(state)) {
        return "";
      }
      return "red--text text--accent-4 font-weight-black";
    },
    getStateColor(state) {
      if ([2, 7, 3, 19].includes(state)) {
        return "green--text text--accent-4";
      }
      if ([13, 4, 17, 18].includes(state)) {
        return "";
      }
      return "red--text text--accent-4";
    },
    getPaymentMethodById(id) {
      const paymentMethods = {
        CARD: 1,
        BANK: 2,
        TICKET: 3,
        PSE: 4,
        CASH: 5,
        DEBIT_CARD: 6,
        OXXO: 9,
        NEQUI: 10,
        BANCOLOMBIA_TRANSFER: 11,
        PAGO_CLAVE: 12,
        MULTIBANCO: 13,
        MBWAY: 14,
        PIX: 15
      };

      switch (id) {
        case paymentMethods.CARD:
          return {
            text: this.$t("transactions.details.creditCard"),
            icon: "credit_card"
          };
        case paymentMethods.BANK:
          return {
            text: this.$t("transactions.details.bank_account"),
            icon: "account_balance"
          };
        case paymentMethods.TICKET:
          return {
            text: this.$t("transactions.details.ticket"),
            icon: "account_balance"
          };
        case paymentMethods.PSE:
          return {
            text: "PSE",
            icon: ""
          };
        case paymentMethods.CASH:
          return {
            text: this.$t("transactions.details.cash"),
            icon: "money"
          };
        case paymentMethods.DEBIT_CARD:
          return {
            text: this.$t("transactions.details.debitCard"),
            icon: "credit_card"
          };
        case paymentMethods.OXXO:
          return {
            text: "OXXO",
            icon: "account_balance"
          };

        case paymentMethods.NEQUI:
          return {
            text: "NEQUI",
            icon: "money"
          };
        case paymentMethods.BANCOLOMBIA_TRANSFER:
          return {
            text: "BANCOLOMBIA_TRANSFER",
            icon: "money"
          };
        case paymentMethods.PAGO_CLAVE:
          return {
            text: "PAGO_CLAVE",
            icon: "money"
          };
        case paymentMethods.MULTIBANCO:
          return {
            text: "MULTIBANCO",
            icon: "money"
          };
        case paymentMethods.MBWAY:
          return {
            text: "MBWAY",
            icon: "money"
          };
        case paymentMethods.PIX:
          return {
            text: "PIX",
            icon: "account_balance"
          };
        default:
          return {
            text: this.$t("transactions.details.creditCard"),
            icon: "credit_card"
          };
      }
    }
  }
};
